const jquery = require('jquery');
window.$ = window.jQuery = jquery;

const typeahead = require('typeahead.js');

import Bloodhound from 'bloodhound-js';
import Granim from 'Granim';
import slick from 'slick-carousel';
import './cc.js';

import './index.scss';

const siteHandle = document.body.getAttribute('data-handle') || 'default';

// Users who prefer reduced motion: keep the gradient static and stop carousel autoplay.
const reduceMotion =
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const CANVAS_GRADDIENTS = {
  default: {
    image: require('./header.jpg'),
    gradients: [
      ['#22D4FD', '#B721FF'],
      ['#FD3381', '#555DCA'],
      ['#D31EFB', '#47BEEE'],
    ],
  },
  essendigitalisiert: {
    image: require('./2022_EWG_Startup_BG.jpg'),
    gradients: [
      ['#002A46', '#002A46'],
      ['#002A46', '#002A46'],
      ['#002A46', '#002A46'],
    ],
  },
};

$(function () {
  //console.log()
  $(
    '.content-wrapper .item h2, .content-wrapper .item img, .content-wrapper .item .text',
  ).on('click', function () {
    var url = $(this).closest('.item').attr('data-url');
    if (!url) return; // keyboard users use the card's inner link instead
    if (url.substring(0, 4) == 'http') {
      window.open(url);
    } else {
      document.location.href = url;
    }
  });
  $(document).delegate(
    'a[href*="http"],a[href*=".pdf"]',
    'click',
    function (e) {
      // Only open EXTERNAL links (different host) and PDFs in a new tab —
      // internal absolute URLs (e.g. CMS nav via entry.url) must stay same-tab.
      var href = this.getAttribute('href') || '';
      var isPdf = /\.pdf(?:$|[?#])/i.test(href);
      var isExternal = this.hostname !== '' && this.hostname !== window.location.hostname;
      if (isExternal || isPdf) {
        this.setAttribute('target', '_blank');
        this.setAttribute('rel', 'noopener noreferrer');
      }
    },
  );
  $(document).delegate('.subpage .beratung', 'click', function (e) {
    $(this).toggleClass('active');
  });
});

var granimInstance = new Granim({
  element: `.canvas-header`,
  name: 'basic-gradient',
  direction: 'left-right',
  opacity: [1, 1],
  isPausedWhenNotInView: true,
  image: {
    source: CANVAS_GRADDIENTS[siteHandle].image,
    position: ['center', 'center'],
    stretchMode: ['stretch', 'stretch'],
    blendingMode: 'hard-light',
  },
  states: {
    'default-state': reduceMotion
      ? { gradients: [CANVAS_GRADDIENTS[siteHandle].gradients[0]] }
      : CANVAS_GRADDIENTS[siteHandle],
  },
  transitionSpeed: 4000,
});

$(function () {
  // Only initialise galleries that actually contain slides — skip empty
  // gallery blocks (otherwise slick + the pause control render on nothing).
  $('.gallery')
    .filter(function () {
      return $(this).find('.gallerySlide, img').length > 0;
    })
    .slick({
    dots: true,
    infinite: true,
    speed: 900,
    autoplay: !reduceMotion,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: '15px',
    variableWidth: true,
    // //initialSlide: 1,
    // pauseOnHover: false,
    // //fade: true,
    // //cssEase: 'linear',
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // WCAG 2.2.2: give the autoplaying carousel an accessible pause control.
  if (!reduceMotion) {
    $('.gallery.slick-initialized').each(function () {
      var $g = $(this);
      var $btn = $(
        '<button type="button" class="gallery-pause" aria-label="Bildergalerie pausieren">' +
          '<span aria-hidden="true">&#10073;&#10073;</span></button>',
      );
      var playing = true;
      $btn.on('click', function () {
        playing = !playing;
        if (playing) {
          $g.slick('slickPlay');
          $btn
            .attr('aria-label', 'Bildergalerie pausieren')
            .find('span')
            .html('&#10073;&#10073;');
        } else {
          $g.slick('slickPause');
          $btn
            .attr('aria-label', 'Bildergalerie abspielen')
            .find('span')
            .html('&#9658;');
        }
      });
      // Overlay the control on the gallery it belongs to, rather than
      // leaving it as a stray block in the layout flow.
      if (!$g.parent('.gallery-frame').length) {
        $g.wrap('<div class="gallery-frame"></div>');
      }
      $g.parent('.gallery-frame').append($btn);
    });
  }

  $('.toggle').on('click', function (e) {
    e.preventDefault();

    var $btn = $(this);
    var $panel = $('#' + $btn.attr('aria-controls'));
    var isOpen = $panel.hasClass('show');
    var $accordion = $btn.closest('.accordion');

    // collapse every panel in this accordion, reset button states
    $accordion.find('.inner.show').removeClass('show').slideUp(350);
    $accordion.find('.toggle').attr('aria-expanded', 'false');

    if (!isOpen) {
      $panel.addClass('show').slideDown(350);
      $btn.attr('aria-expanded', 'true');
    }
  });
});

function initNavigation() {
  $(window)
    .resize(function () {
      if (document.getElementById('jumbo') != null) {
        var jh = $('#jumbo').outerHeight();
        var ot = $('#jumbo').offset().top;
        $('#searchinnerwrapper').css({ top: jh + ot });
      }
    })
    .trigger('resize');

  var offset = $('#searchinnerwrapper').offset();
  //console.log(offset.top);

  // constructs the suggestion engine
  var myTags = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('title'),
    // datumTokenizer: function(d) {
    //     var test = Bloodhound.tokenizers.whitespace(d.value);
    //         $.each(test,function(k,v){
    //             i = 0;
    //             while( (i+1) < v.length ){
    //                 test.push(v.substr(i,v.length));
    //                 i++;
    //             }
    //         })
    //         return test;
    //     },
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    prefetch: {
      url: '/json',
      ttl: 100,
    },
  });

  function tagsWithDefaults(q, sync) {
    if (q === '') {
      // first five elements of array
      sync(myTags.all().slice(0, 7));
    } else {
      myTags.search(q, sync);
    }
  }

  $('#searchfield')
    .typeahead(
      {
        hint: true,
        highlight: false,
        minLength: 0,
      },
      {
        name: 'my-tags',
        limit: 7,
        display: 'title',
        source: tagsWithDefaults,
      },
    )
    .bind('typeahead:select', function (ev, suggestion) {
      //console.log('Selection: ' + suggestion);
      window.location = suggestion.url;
    })
    .bind('typeahead:close', function (ev, suggestion) {
      $('#searchwrapper').removeClass('active');
      $('body').focus();
      var jh = $('#jumbo').outerHeight();
      var ot = $('#jumbo').offset().top;
      $('#searchinnerwrapper').css({ top: jh + ot });
      $('.subpage #searchinnerwrapper').css({ top: '25px' });
    })
    .bind('typeahead:active', function (ev, suggestion) {
      $('#searchinnerwrapper').css({ top: offset.top - $(window).scrollTop() });
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        )
      ) {
        $('#searchinnerwrapper').css({ top: '25px' });
      }
    })
    .on('keypress', function (evt) {
      if (evt.which == 13 /* ENTER */) {
        const typeahead = $(this).data().ttTypeahead;
        const hintText = typeahead.input.$hint.val();
        const menu = typeahead.menu;
        const sel = menu.getActiveSelectable() || menu.getTopSelectable();
        if (menu.isOpen()) {
          menu.trigger('selectableClicked', sel);
          evt.preventDefault();
        }
      }
    });

  var searchwrapper = document.getElementById('searchwrapper');

  document.getElementById('searchfield').onfocus = function () {
    searchwrapper.className += ' active';
  };

  document.getElementById('searchclose').onclick = function () {
    searchwrapper.classList.remove('active');
  };
}

if (siteHandle != 'essendigitalisiert') initNavigation();

const hamburgerElement = document.querySelector('.hamburger');
const navCloseElement = document.querySelector('.navclose');
const wrapperElement = document.querySelector('.menu-wrapper');
// These only render on the default site; guard so the ED page doesn't throw.
if (hamburgerElement) {
  hamburgerElement.addEventListener('click', () => {
    document.body.classList.add('navactive');
  });
}
if (navCloseElement) {
  navCloseElement.addEventListener('click', () => {
    document.body.classList.remove('navactive');
  });
}
if (wrapperElement) {
  wrapperElement.addEventListener('click', () => {
    document.body.classList.remove('navactive');
  });
}

// Accessible modal (used by the ED "Anmeldung" menu item → guestoo embed).
// Runs on any page that contains a [data-modal-open] trigger.
(function initModals() {
  const openers = document.querySelectorAll('[data-modal-open]');
  if (!openers.length) return;

  let activeModal = null;
  let lastFocused = null;

  const focusables = (modal) =>
    modal.querySelectorAll(
      'a[href], button:not([disabled]), iframe, input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );

  const loadGuestooSupport = () => {
    if (document.getElementById('guestoo-frame-support')) return;
    const s = document.createElement('script');
    s.id = 'guestoo-frame-support';
    s.src = 'https://app.guestoo.de/frame-support.js';
    document.body.appendChild(s);
  };

  // Make everything except the modal non-interactive (inert) while it is open,
  // so AT and keyboard users can't reach the background. Complements aria-modal;
  // ignored gracefully by browsers without `inert` support.
  const setBackgroundInert = (modal, on) => {
    Array.prototype.forEach.call(document.body.children, (el) => {
      if (el === modal || el.tagName === 'SCRIPT') return;
      if (on) el.setAttribute('inert', '');
      else el.removeAttribute('inert');
    });
  };

  const onKeydown = (e) => {
    if (!activeModal) return;
    if (e.key === 'Escape') {
      closeModal(activeModal);
      return;
    }
    if (e.key === 'Tab') {
      const f = activeModal.querySelectorAll('.modal__dialog')[0]
        ? focusables(activeModal.querySelector('.modal__dialog'))
        : focusables(activeModal);
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  };

  function openModal(modal, opener) {
    lastFocused = opener;
    activeModal = modal;
    // lazy-load the embedded iframe (and its support script) on first open
    const iframe = modal.querySelector('iframe[data-src]');
    if (iframe && !iframe.getAttribute('src')) {
      iframe.setAttribute('src', iframe.getAttribute('data-src'));
      loadGuestooSupport();
    }
    modal.hidden = false;
    document.body.classList.add('modal-open');
    setBackgroundInert(modal, true);
    const closeBtn = modal.querySelector('.modal__close');
    const first = focusables(modal.querySelector('.modal__dialog') || modal)[0];
    (closeBtn || first || modal).focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeModal(modal) {
    modal.hidden = true;
    // lift inert before restoring focus (you can't focus an inert element)
    setBackgroundInert(modal, false);
    document.body.classList.remove('modal-open');
    document.removeEventListener('keydown', onKeydown);
    activeModal = null;
    if (lastFocused) lastFocused.focus();
  }

  openers.forEach((btn) => {
    btn.addEventListener('click', () => {
      const modal = document.getElementById(btn.getAttribute('data-modal-open'));
      if (modal) openModal(modal, btn);
    });
  });

  document.querySelectorAll('[data-modal-close]').forEach((el) => {
    el.addEventListener('click', () => {
      const modal = el.closest('.modal');
      if (modal) closeModal(modal);
    });
  });
})();

/* Consent-gated third-party embeds (YouTube, OpenStreetMap): click-to-load.
   No request reaches the provider until the visitor actively loads the embed
   (GDPR/TTDSG prior-consent). The choice is remembered per provider in
   localStorage, so once a visitor loads one YouTube video, further YouTube
   embeds on the site load without a second click. */
(function () {
  var STORAGE_KEY = 'embedConsent';

  function consentedProviders() {
    try {
      return (localStorage.getItem(STORAGE_KEY) || '').split(',').filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function remember(provider) {
    try {
      var set = consentedProviders();
      if (set.indexOf(provider) === -1) {
        set.push(provider);
        localStorage.setItem(STORAGE_KEY, set.join(','));
      }
    } catch (e) { /* storage blocked — consent stays per-click */ }
  }

  function load(el, autoplay) {
    if (el.classList.contains('embed-consent--loaded')) return;
    var src = el.getAttribute('data-embed-src');
    if (!src) return;
    if (autoplay) src += (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', src);
    iframe.setAttribute('title', el.getAttribute('data-embed-title') || '');
    iframe.setAttribute('width', '560');
    iframe.setAttribute('height', '315');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    el.innerHTML = '';
    el.appendChild(iframe);
    el.classList.add('embed-consent--loaded');
  }

  var embeds = document.querySelectorAll('.embed-consent');
  if (!embeds.length) return;

  var consented = consentedProviders();

  embeds.forEach(function (el) {
    var provider = el.getAttribute('data-embed') || 'embed';
    // Already consented this provider (earlier click, remembered): auto-load,
    // but do NOT autoplay — the visitor didn't just ask for this one.
    if (consented.indexOf(provider) !== -1) {
      load(el, false);
      return;
    }
    var btn = el.querySelector('.embed-consent__btn');
    if (!btn) return;
    btn.addEventListener('click', function () {
      remember(provider);
      load(el, true);
      // Load any other still-blocked embeds from the same provider now that the
      // visitor has consented to it (without autoplaying them).
      document.querySelectorAll('.embed-consent').forEach(function (other) {
        if (other !== el && (other.getAttribute('data-embed') || 'embed') === provider) {
          load(other, false);
        }
      });
    });
  });
})();
